import HttpClient from "../../../../core/HttpClient";
import { Authentication } from "@leedpulse-monorepo/classes";

/**
 * Avatars des titulaires du top abonnements, par uid. Demandés après
 * `getOverviewStats` : stockés en base64 dans `Users`, ils alourdissaient
 * toute la page alors qu'une dizaine seulement s'affiche.
 */
async function getOverviewAvatars(
    auth: Authentication | null,
    uids: string[],
): Promise<Record<string, string>> {
    if (!auth || uids.length === 0) return {};

    const response = await HttpClient.post('/leedflow/overview-avatars', { uids }, auth.token);
    return (response?.avatars ?? {}) as Record<string, string>;
}

export default getOverviewAvatars;
